import React, { Component } from "react";
import { formBuilderGroups } from "../../../variables/formBuilderData";
import Collapsible from "react-collapsible";
import { translate } from "../../../utils/useful";


class FormBuilderInputOptions extends Component {
    state = {
        closedGroups: {},
        showChildsSide: false
    };

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }
    nextPage = (formItem) => {
        console.log('formItem',formItem)
        // console.log('formItem!',this.convertItem(formItem))
        let myForm = {...formItem}
        // myForm.headers = this.convertItem(formItem)
        // this.props.setData(({ formdata: data }))
        this.props.setData(({ formdata: myForm}), () => {
            this.props.changeStage('config')
            // console.log('this.props.', item)
        })

    }




    render() {
        const { formItems, hideHandlers } = this.props;

        return (
            <div className="column-forms-holder ">
                <div className="w-100 px-3 pb-3 pt-3 mb-3 flexc" style={{ background: 'linear-gradient(to right, #4685cccb, #4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="flexc">

                        {/* <div className='mrd-2 flexcc'>
                            <button onClick={() => this.props.lastStage()} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                    <img className='invert rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                </div>
                            </button>
                        </div> */}
                        <p className="color-white text-normal text-bold color-gray-3 m-0 mx-1">{translate("Select Field")}</p>
                    </div>

                    {/* <button onClick={() => { this.props.onSave() }} className='px-1 py-1  flexcc ' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{this.props.saveTitle}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/useful/save.svg' height={18} />
                        </div>
                    </button> */}
                </div>

                {Object.values(formBuilderGroups).map((group, index) => {
                    return (

                        <div className="mb-3 pb-2 px-2 w-100" style={{ borderBottom: '1px solid #eee' }} key={group.key}>
                            <button className="p-0 px-2  flexcb w-100" onClick={() => this.toggleOpen(group.key)} >
                                <div className="text-start">
                                    <p className="text-normal color-gray-3 ">{group.title}</p>
                                </div>
                                <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[group.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                            </button>
                            <Collapsible open={!this.state.closedGroups[group.key]} transitionTime={100}>
                                <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>

                                    {formItems.map((formItem, index) => {
                                        if (formItem.parent === group.key)
                                            return (
                                                <div onClick={() => this.nextPage(formItem)} className="formItems-container p-1 mb-0" style={{ width: '50%' }} key={formItem.type}>
                                                    <div key={index} className="form-item w-100 flexcc flex-column text-smaller pt-2 pb-2">
                                                        <img src={formItem.icon} height={30} />
                                                        <p className="mt-2 text-semibold color-gray-3">{formItem.label}</p>
                                                    </div>
                                                </div>
                                            );
                                    })
                                    }
                                </div>
                            </Collapsible>
                        </div>
                    )
                })}

            </div>
        );
    }
}



export default FormBuilderInputOptions;